'use client'

import { type FC, type PropsWithChildren } from 'react'

import { experimentComponentCompileAndGetExperiment } from '../../../experiments/components/experimentComponentCompiler'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import { experimentAccessorIsValidExperimentVariation } from '../../../experiments/model/experimentAccessor'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokOptimizelyExperimentType } from '../../storyblok'

import { StoryblokOptimizelyExperimentActivation } from './StoryblokOptimizelyExperimentActivation'

export const StoryblokOptimizelyExperimentContent: FC<
  PropsWithChildren<StoryblokComponentProps<StoryblokOptimizelyExperimentType>>
> = ({ blok, children }) => {
  const { experiments } = useExperimentsContext()

  const experiment = experimentComponentCompileAndGetExperiment(
    blok.name.split(/[,\s]+/u),
    experiments,
  )

  const { variation } = blok

  if (!experimentAccessorIsValidExperimentVariation(variation)) {
    return null
  }

  const shouldRender =
    variation ===
    (experiment.isEnabled ? experiment.variant : EXPERIMENT_VARIATION.DEFAULT)

  if (!shouldRender) {
    return null
  }

  return (
    <>
      {experiment.isEnabled ? (
        <StoryblokOptimizelyExperimentActivation
          experimentName={experiment.name}
        />
      ) : null}
      {children}
    </>
  )
}
